const es = {
  app: {
    label: {
      true: 'Sí',
      false: 'No',
    },
    loginWidget: {
      email: 'Correo electrónico',
      forgotPassword: '¿Ha olvidado su contraseña?',
      login: 'Iniciar sesión',
      loginWelcome:
        'Bienvenido de nuevo. Inicie sesión con sus credenciales registradas.',
      next: 'Siguiente',
      password: 'Contraseña',
      title: 'Inicio de sesión',
    },
    resetWidget: {
      title: '¿Ha olvidado su contraseña?',
      instructions:
        'Introduzca su dirección de correo electrónico. Si existe una cuenta asociada a esta dirección, recibirá instrucciones para restablecer su contraseña.',
      emailLabel: 'Dirección de correo electrónico',
      emailPlaceholder: 'Introduzca su dirección de correo electrónico',
      back: 'Volver al inicio de sesión',
      submit: 'Enviar',
      submitSso: 'Ir al portal de inicio de sesión único (SSO)',
    },
    resetConfirmationWidget: {
      title: 'Nueva contraseña solicitada',
      confirmation:
        'Revise la bandeja de entrada de su correo electrónico para obtener más instrucciones.',
      back: 'Volver al inicio de sesión',
    },
    changePasswordWidget: {
      title: 'Establecer contraseña',
      forcedTitle: 'Restablecer contraseña',
      instructions:
        'Establezca su nueva contraseña teniendo en cuenta nuestras recomendaciones de seguridad para contraseñas.',
      placeholder: 'Contraseña',
      newPasswordLabel: 'Establecer nueva contraseña',
      confirmationLabel: 'Repetir nueva contraseña',
      confirmationError: 'Las contraseñas no coinciden',
      backToLogin: 'Ir al inicio de sesión',
      back: 'Atrás',
      submit: 'Establecer contraseña',
      recommendations: {
        characterCount: 'mín. 10 caracteres',
        containing: 'que incluya',
      },
    },
    logout: 'Cerrar sesión',
    inactivityLogout:
      'Se ha cerrado su sesión por inactividad. Vuelva a iniciar sesión con sus credenciales.',
    switchToLightTheme: 'Cambiar al tema claro',
    switchToDarkTheme: 'Cambiar al tema oscuro',
    changePassword: 'Cambiar contraseña',
    settings: 'Configuración',
    radioGroup: {
      current: 'Actual',
    },
    userSettings: {
      title: 'Configuración de usuario',
      loginInformation: 'Información de inicio de sesión',
      loginDescription:
        'Consulte la información de su cuenta y cambie su contraseña',
      portalSettings: 'Configuración del portal',
      email: 'Correo electrónico',
      language: 'Idioma del portal',
      colorMode: 'Modo de color',
      lightMode: 'Modo claro',
      darkMode: 'Modo oscuro',
      cancel: 'Cancelar',
      saveAndExit: 'Guardar y salir',
    },
    genericListWithLayoutModal: {
      title: 'Configuración de la comparación',
      cancel: 'Cancelar',
      apply: 'Comparar',
      layoutLabel: 'Diseño',
    },
    page: {
      loadingError: 'No se pudo cargar la aplicación',
      genericError: 'Se ha producido un error',
      pageNotFoundError: 'Página no encontrada',
      unknownPageContentNodeError: 'Nodo de contenido de página desconocido',
      retry: 'Reintentar',
      notLoadedTitle: 'No se pudo cargar la página',
      notLoadedErrorText:
        'La página que busca no existe o se ha producido un error. Inténtelo de nuevo o póngase en contacto con su administrador.',
      pageContentErrorTitle: 'Error en el contenido de la página',
      contentNotFoundError:
        'Se ha producido un problema al cargar el contenido. Actualice la página o inténtelo de nuevo más tarde.',
      backToDashboard: 'Volver al panel de control',
      close: 'Cerrar página de detalle',
      editAction: {
        label: {
          customizePage: 'Personalizar página',
          archive: 'Archivar',
          delete: 'Eliminar',
          share: 'Compartir',
          addComponent: 'Añadir componente',
          save: 'Guardar',
        },
        addComponentModal: {
          title: 'Añadir componente',
          cancel: 'Cancelar',
          add: 'Añadir componentes',
          emptyCategories:
            'No hay categorías configuradas en la biblioteca de contenidos.',
          noResults: 'No se encontraron componentes coincidentes.',
          untitled: 'Sin título',
          loadError:
            'No se pudieron cargar los datos de la biblioteca de contenidos. Inténtelo de nuevo.',
          searchError:
            'No se pudieron cargar los componentes. Inténtelo de nuevo.',
          selectComponentsInstruction:
            'Seleccione uno o varios componentes para añadirlos a su panel de control',
          tables: 'Tablas',
          charts: 'Gráficos',
        },
      },
    },
    pageFilter: {
      placeholder: 'Todos',
      reset: 'Restablecer filtros',
      autoSaveEnabled: 'La selección de filtros se guarda automáticamente',
      autoSaveDisabled: 'La selección de filtros no se guarda automáticamente',
      autoSaveForceEnabled:
        'La selección de filtros se guarda automáticamente. Esta opción no se puede desactivar.',
      manualSave: 'Guardar la selección de filtros actual',
      calendarFilter: {
        defaultTitle: 'Fecha',
        placeholder: 'Seleccione una fecha',
      },
      dateRangeFilter: {
        placeholderFrom: 'Desde',
        placeholderTo: 'Hasta',
      },
      monthRangeFilter: {
        presets: {
          qtd: 'QTD',
          ytd: 'YTD',
          sinceInception: 'Desde el inicio',
        },
      },
      comparisonFilter: {
        baseEntity: 'Entidad base',
        comparisonEntity: 'Entidad de comparación',
        multipleComparisonFiltersError:
          'Error de configuración: solo se permite un filtro de comparación por página.',
      },
    },
    pagination: {
      summary:
        '{{firstShownEntry, number}} - {{lastShownEntry, number}} de {{totalEntries, number}} entradas',
      summaryShort:
        '{{totalEntries, number}} de {{totalEntries, number}} entradas',
      selectItem: '{{entries, number}} por página',
      selectedRows: 'Seleccionados: {{selectedRowsCount, number}}',
      entryLimit: ' (limitado a {{totalEntries, number}} entradas)',
    },
    pageReference: {
      reference_one: 'pág. {{pages}}',
      reference_many: 'págs. {{pages}}',
      reference_other: 'págs. {{pages}}',
    },
    table: {
      tooltip: {
        maliciousContent:
          'Nuestras comprobaciones indican que el archivo cargado podría contener contenido activo o incluso malicioso. Por este motivo, se ha bloqueado para cualquier otra acción.',
      },
      searchResultPagination:
        '{{shownResults, number}} de {{totalResults, number}} resultados',
      customizationModal: {
        title: 'Configuración de la tabla',
        divider: 'Mueva las columnas fijas por encima de esta barra',
        groupedDivider: 'Mueva las columnas agrupadas por encima de esta barra',
        resetChanges: 'Restablecer la configuración predeterminada',
        cancel: 'Cancelar',
        apply: 'Guardar y salir',
        selectAll: 'Seleccionar todo',
        groupingHeader:
          'Puede agrupar esta tabla por hasta {{maxColumns, number}} columnas a la vez.',
        groupingNote:
          'Tenga en cuenta que solo determinadas columnas permiten agrupación.',
      },
      filterModal: {
        title: 'Configuración de filtros',
        resetChanges: 'Eliminar todos los filtros',
        cancel: 'Cancelar',
        apply: 'Guardar y salir',
        selectAll: 'Seleccionar todo',
      },
      showMoreEntry_one: '+ {{ count }} entrada más',
      showMoreEntry_many: '+ {{ count }} entradas más',
      showMoreEntry_other: '+ {{ count }} entradas más',
      workflowActionModal: {
        apply: 'Confirmar',
        cancel: 'Cancelar',
        successMessage: 'La acción se ha ejecutado correctamente.',
        fileUploadRequired: 'Se requiere al menos un archivo.',
        actionSuccessfulCountTimes_one:
          'La acción se ha ejecutado correctamente para {{ count }} elemento,',
        actionSuccessfulCountTimes_many:
          'La acción se ha ejecutado correctamente para {{ count }} elementos,',
        actionSuccessfulCountTimes_other:
          'La acción se ha ejecutado correctamente para {{ count }} elementos,',
        actionFailedCountTimes_one: 'pero ha fallado para {{ count }} elemento',
        actionFailedCountTimes_many:
          'pero ha fallado para {{ count }} elementos',
        actionFailedCountTimes_other:
          'pero ha fallado para {{ count }} elementos',
      },
      documentSigning: {
        initializationErrorNotification:
          'Se ha producido un error al iniciar el proceso de firma del documento',
        finalizingErrorNotification:
          'Se ha producido un error al finalizar el proceso de firma del documento',
        finalizingNotification: 'Finalizando la firma del documento',
        successNotification: 'El documento se ha firmado correctamente',
      },
      deleteConfirmation: {
        cancel: 'Cancelar',
        apply: 'Eliminar',
        title: 'Eliminar',
        message_one: '¿Está seguro de que desea eliminar esta fila?',
        message_many: '¿Está seguro de que desea eliminar {{count}} filas?',
        message_other: '¿Está seguro de que desea eliminar {{count}} filas?',
      },
    },
    monthQuarterPicker: {
      modeMonthly: 'Mensual',
      modeQuarterly: 'Trimestral',
      placeholderMonth: 'Seleccione un mes',
      placeholderQuarter: 'Seleccione un trimestre',
      placeholderYear: 'Seleccione un año',
    },
    periodPicker: {
      month: 'Mes',
      quarter: 'Trimestre',
    },
    periodRangePicker: {
      earlier: 'Periodos anteriores',
      from: 'Desde',
      later: 'Periodos posteriores',
      to: 'Hasta',
    },
    datepicker: {
      qtd: 'Trimestre en curso hasta la fecha',
      qtdShort: 'QTD',
      ytd: 'Año en curso hasta la fecha',
      ytdShort: 'YTD',
      ltm: 'Últimos doce meses',
      ltmShort: 'LTM',
      sinceInception: 'Todas las fechas hasta hoy',
      sinceInceptionShort: 'Desde el inicio',
    },
    select: {
      noOptionsAvailable: 'No hay opciones disponibles',
      noOptionsFound: 'Ninguna opción coincide con el término de búsqueda',
      createOption: 'Crear "{{value}}"',
      creatableHint: 'Puede añadir nuevas entradas escribiendo en el campo.',
      selectAbove: 'Seleccionar todas las opciones anteriores',
    },
    search: {
      placeholder: 'Buscar',
    },
    noAccessError: {
      headline: 'Acceso a la aplicación denegado',
      message: 'No está autorizado para acceder a esta aplicación.',
      resolution:
        'Si considera que se trata de un error, solicite ayuda a su persona de contacto de soporte.',
      logoutButton: 'Cerrar sesión',
    },
    fullScreenError: {
      loadingError: 'No se pudo cargar la aplicación',
      genericError: 'Se ha producido un error',
      actions: {
        retry: 'Reintentar',
        logout: 'Cerrar sesión',
      },
      tenantNotFound: {
        headline: 'Configuración de cliente no encontrada',
        message:
          'La configuración de cliente solicitada <strong>{{tenantName}}</strong> no está disponible. ¿Ha utilizado la URL correcta?',
      },
      serviceUnavailable: {
        headline: 'Servicio temporalmente no disponible',
        message:
          'Esta aplicación se encuentra actualmente en mantenimiento. Inténtelo de nuevo más tarde.',
      },
      networkError: {
        headline: 'Error de red',
        message:
          'Un error de red ha impedido cargar la aplicación. Compruebe su conexión de red e inténtelo de nuevo.',
      },
      plannedMaintenance: {
        headline: 'Servicio en mantenimiento',
        message:
          'Esta aplicación se encuentra actualmente en un mantenimiento programado. Inténtelo de nuevo más tarde.',
      },
    },
    tenantNotFoundError: {
      headline: 'Configuración de cliente no encontrada',
      message:
        'La configuración de cliente solicitada <strong>{{tenantName}}</strong> no está disponible. ¿Ha utilizado la URL correcta?',
      action: 'Actualice la página',
    },
    networkError: {
      message:
        'No se puede conectar con el servidor. Compruebe su conexión a Internet e inténtelo de nuevo.',
    },
    tenantConfigurationLoading: {
      headline: 'Cargando la configuración',
    },
    tenantPortalDataLoading: {
      headline: 'Cargando los datos del portal',
    },
    notifications: {
      goToPage: 'Ir a la página',
      copyContentId: {
        success: 'ID copiado al portapapeles.',
        error: 'No se pudo copiar el ID. Cópielo manualmente: {{id}}',
      },
      export: {
        error:
          'No se pudieron descargar los datos exportados <strong>{{fileName}}</strong>.',
        loading:
          'Descargando los datos exportados <strong>{{fileName}}</strong>.',
        success:
          'Los datos exportados <strong>{{fileName}}</strong> se han descargado correctamente.',
      },
      filterPersistence: {
        error: 'No se pudo guardar la selección de filtros actual.',
        loading: 'Guardando la selección de filtros actual.',
        success: 'La selección de filtros actual se ha guardado correctamente.',
      },
      bulkDownload: {
        error_one:
          'No se pudo generar el archivo comprimido con {{count}} documento.',
        error_many:
          'No se pudo generar el archivo comprimido con {{count}} documentos.',
        error_other:
          'No se pudo generar el archivo comprimido con {{count}} documentos.',
        loading_one: 'Generando el archivo comprimido con {{count}} documento.',
        loading_many:
          'Generando el archivo comprimido con {{count}} documentos.',
        loading_other:
          'Generando el archivo comprimido con {{count}} documentos.',
        success_one:
          'Se ha iniciado la descarga del archivo comprimido con {{count}} documento.',
        success_many:
          'Se ha iniciado la descarga del archivo comprimido con {{count}} documentos.',
        success_other:
          'Se ha iniciado la descarga del archivo comprimido con {{count}} documentos.',
      },
      downloadRow: {
        error:
          'No se pudieron cargar los datos de la fila de la tabla: {{- message}}',
        loading_one: 'Cargando los datos de {{count}} fila',
        loading_many: 'Cargando los datos de {{count}} filas',
        loading_other: 'Cargando los datos de {{count}} filas',
        success_one: 'Iniciando la descarga de los datos de {{count}} fila',
        success_many: 'Iniciando la descarga de los datos de {{count}} filas',
        success_other: 'Iniciando la descarga de los datos de {{count}} filas',
      },
      rowRequest: {
        error: 'No se pudo ejecutar la solicitud "{{label}}": {{- message}}',
        loading_one: 'Enviando la solicitud "{{label}}" para {{count}} fila',
        loading_many: 'Enviando la solicitud "{{label}}" para {{count}} filas',
        loading_other: 'Enviando la solicitud "{{label}}" para {{count}} filas',
        success_one:
          'Solicitud "{{label}}" ejecutada correctamente para {{count}} fila',
        success_many:
          'Solicitud "{{label}}" ejecutada correctamente para {{count}} filas',
        success_other:
          'Solicitud "{{label}}" ejecutada correctamente para {{count}} filas',
      },
      markAsRead: {
        error_one: 'No se pudo marcar el documento como leído.',
        error_many: 'No se pudieron marcar {{count}} documentos como leídos.',
        error_other: 'No se pudieron marcar {{count}} documentos como leídos.',
        success_one: 'El documento se ha marcado como leído correctamente.',
        success_many:
          '{{count}} documentos se han marcado como leídos correctamente.',
        success_other:
          '{{count}} documentos se han marcado como leídos correctamente.',
      },
      markAsUnread: {
        error_one: 'No se pudo marcar el documento como no leído.',
        error_many:
          'No se pudieron marcar {{count}} documentos como no leídos.',
        error_other:
          'No se pudieron marcar {{count}} documentos como no leídos.',
        success_one: 'El documento se ha marcado como no leído correctamente.',
        success_many:
          '{{count}} documentos se han marcado como no leídos correctamente.',
        success_other:
          '{{count}} documentos se han marcado como no leídos correctamente.',
      },
      delete: {
        error_one: 'No se pudo eliminar la fila.',
        error_many: 'No se pudieron eliminar {{count}} filas.',
        error_other: 'No se pudieron eliminar {{count}} filas.',
        success_one: 'La fila se ha eliminado correctamente.',
        success_many: '{{count}} filas se han eliminado correctamente.',
        success_other: '{{count}} filas se han eliminado correctamente.',
      },
      documentDownload: {
        loading: 'Descargando el documento <strong>{{fileName}}</strong>.',
        success:
          'El documento <strong>{{fileName}}</strong> se ha descargado correctamente.',
        error:
          'No se pudo descargar el documento <strong>{{fileName}}</strong>.',
      },
      staticFileDownload: {
        loading: 'Descargando el archivo.',
        success: 'El archivo se ha descargado correctamente.',
        error: 'No se pudo descargar el archivo.',
      },
      maintenance: {
        title: 'Modo de mantenimiento',
        plannedMaintenanceMessage:
          'Esta aplicación se encuentra actualmente en un mantenimiento programado. Inténtelo de nuevo más tarde.',
        message:
          'Esta aplicación se encuentra actualmente en mantenimiento. Inténtelo de nuevo más tarde.',
        action: 'Recargar página',
      },
    },
    dataRefresh: {
      dataRefreshlabel: 'Última actualización de datos',
      closedQuarterLabel: 'Último trimestre cerrado',
      tooltip:
        'Última actualización de datos: {{formattedRefreshDate}}\nÚltimo trimestre cerrado: {{formattedClosedQuarterDate}}',
      tooltipWithDataRefresh:
        'Última actualización de datos: {{formattedRefreshDate}}',
      tooltipWithClosedQuarted:
        'Último trimestre cerrado: {{formattedClosedQuarterDate}}',
    },
    disclaimer: {
      accept: 'Acepto',
      cancel: 'Cancelar',
      defaultTitle: 'Descargo de responsabilidad',
    },
    detailPageCreationModal: {
      title: 'Configuración de la comparación',
      cancel: 'Cancelar',
      apply: 'Comparar',
      layoutLabel: 'Diseño',
      filteredRowsWarning:
        'Se han excluido algunas filas seleccionadas porque no contienen datos o tienen identificadores duplicados para este diseño.',
    },
    widget: {
      action: {
        label: {
          additionalInformation: 'Información adicional',
          bulkActions: 'Acciones en bloque',
          closeFullscreen: 'Salir de la pantalla completa',
          downloadCsvUnfiltered: 'Descargar todos los datos como CSV',
          downloadCsvFiltered: 'Descargar los datos filtrados como CSV',
          downloadCsvSelectedRows: 'Descargar las filas seleccionadas como CSV',
          customFilter: 'Filtros personalizados de la tabla',
          customization: 'Personalización de la tabla',
          delete: 'Eliminar',
          download: 'Descargar documentos',
          edit: 'Editar',
          downloadXlsxFiltered: 'Descargar los datos filtrados como Excel XLSX',
          downloadXlsxSelectedRows:
            'Descargar las filas seleccionadas como Excel XLSX',
          downloadXlsxReadOnly:
            'Descargar la pista de auditoría como Excel XLSX',
          downloadXlsxUnfiltered: 'Descargar todos los datos como Excel XLSX',
          downloadGroupDataXlsx:
            'Descargar los datos de los grupos como Excel XLSX',
          downloadGroupDataCsv: 'Descargar los datos de los grupos como CSV',
          imageDownload: 'Descargar el gráfico como imagen',
          imageDownloadWithBackground:
            'Descargar el gráfico como imagen con fondo',
          initFoundOperation: 'Crear operación del fondo',
          markAsRead: 'Marcar como leído',
          markAsUnread: 'Marcar como no leído',
          openInFullscreen: 'Abrir en pantalla completa',
          shareActions: 'Compartir y exportar',
          createRow: 'Crear fila',
          createInvestmentLimit: 'Crear límite',
          dataIngestion: 'Crear flujo de trabajo de importación de datos',
          downloadStaticFile: 'Descargar',
          copyContentId: 'Copiar ID de contenido (API)',
          openDetailPage: 'Abrir detalles de {{label}}',
          compareData: 'Comparar datos',
          aggregateData: 'Ver datos agregados',
          moveContentUp: 'Mover el contenido hacia arriba',
          moveContentDown: 'Mover el contenido hacia abajo',
          toggleContentWidth: 'Alternar el ancho del contenido',
          duplicateContent: 'Duplicar el contenido',
          removeContent: 'Quitar el contenido',
        },
        tooltip: {
          compareData: 'Seleccione al menos dos filas para comparar los datos',
          aggregateData:
            'Seleccione al menos dos filas para ver los datos agregados',
          downloadCsvUnfiltered:
            'Descarga los datos como CSV sin filtros aplicados. Solo se incluyen en la descarga las columnas visibles de la tabla. Se aplica la configuración personalizada de la tabla.',
          downloadCsvFiltered:
            'Descarga los datos como CSV con los filtros actuales aplicados. Solo se incluyen en la descarga las columnas visibles de la tabla. Se aplica la configuración personalizada de la tabla.',
          downloadCsvSelectedRows:
            'Descarga como CSV únicamente las filas seleccionadas actualmente. Se sigue aplicando la configuración personalizada actual de la tabla.',
          downloadXlsxFiltered:
            'Descarga los datos como Excel XLSX con los filtros actuales aplicados. Solo se incluyen en la descarga las columnas visibles de la tabla. Se aplica la configuración personalizada de la tabla.',
          downloadXlsxSelectedRows:
            'Descarga como Excel XLSX únicamente las filas seleccionadas actualmente. Se sigue aplicando la configuración personalizada actual de la tabla.',
          downloadXlsxUnfiltered:
            'Descarga los datos como Excel XLSX sin filtros aplicados. Solo se incluyen en la descarga las columnas visibles de la tabla. Se aplica la configuración personalizada de la tabla.',
          downloadXlsxReadOnly:
            'Descarga los datos como Excel XLSX de solo lectura con los filtros actuales aplicados. Solo se incluyen en la descarga las columnas visibles de la tabla. Se aplica la configuración personalizada de la tabla.',
          downloadGroupDataXlsx:
            'Descarga como Excel XLSX únicamente las filas agregadas de los grupos. Las filas de datos individuales no se incluyen.',
          downloadGroupDataCsv:
            'Descarga como CSV únicamente las filas agregadas de los grupos. Las filas de datos individuales no se incluyen.',
          copyContentId:
            'Se puede acceder a los datos de este widget a través de nuestra API mediante el ID de contenido.',
        },
      },
    },
    upload: {
      zipUploadModal: {
        headline: 'Cargar documentos',
      },
      title_one: 'Arrastre y suelte su archivo aquí o ',
      title_many: 'Arrastre y suelte sus archivos aquí o ',
      title_other: 'Arrastre y suelte sus archivos aquí o ',
      subtitle_one: 'seleccione un archivo.',
      subtitle_many: 'seleccione los archivos.',
      subtitle_other: 'seleccione los archivos.',
      permittedFormats: 'Formatos permitidos',
      maxFileSize: 'Tamaño máx. de archivo',
      maxTotalSize: 'Tamaño total máx.',
      maxTotalSizeExceeded:
        'El tamaño total de la carga no debe superar {{maxTotalSize}}.',
      maxFileCount: 'Número máx. de archivos',
      upload: 'Cargar',
      uploadDocuments: 'Cargar documentos',
      uploading: 'Cargando',
      fetchingMetadata: 'Cargando',
      cancel: 'Cancelar',
      close: 'Cerrar',
      okay: 'Aceptar',
      uploadFailed: 'Error en la carga',
      rejected: 'Archivos rechazados',
      addedToUpload: 'Archivos añadidos',
      fileSummary_one: '{{ count }} archivo | {{ totalFileSize }}',
      fileSummary_many: '{{ count }} archivos | {{ totalFileSize }}',
      fileSummary_other: '{{ count }} archivos | {{ totalFileSize }}',
      info: {
        progress_one: 'El archivo se ha cargado correctamente.',
        progress_many:
          'Se han cargado correctamente {{ count }} de {{ total, number }} archivos.',
        progress_other:
          'Se han cargado correctamente {{ count }} de {{ total, number }} archivos.',
        problemCount_one: 'Se ha producido un problema al cargar 1 archivo.',
        problemCount_many:
          'Se ha producido un problema al cargar {{count}} archivos.',
        problemCount_other:
          'Se ha producido un problema al cargar {{count}} archivos.',
      },
      uploadedFiles: 'Archivos cargados',
      conditionalFilterOptionsError:
        'Se ha producido un error del sistema al cargar los metadatos. Cancele este proceso e inténtelo de nuevo.',
      uploadZip: 'Cargar archivo ZIP',
      back: 'Atrás',
      extractMetaData: {
        title: 'Metadatos leídos del documento',
        checkBtnLabel: 'Revisar los metadatos específicos del archivo',
        fileName: 'Nombre de archivo',
        size: 'Tamaño',
        totalFiles_one:
          'Los metadatos se han leído correctamente de {{success, number}} archivo.',
        totalFiles_many:
          'Los metadatos se han leído correctamente de {{success, number}} de {{count}} archivos.',
        totalFiles_other:
          'Los metadatos se han leído correctamente de {{success, number}} de {{count}} archivos.',
        failedToExtract_one:
          'Se ha producido un error al asignar los metadatos de {{count}} archivo.',
        failedToExtract_many:
          'Se ha producido un error al asignar los metadatos de {{count}} archivos.',
        failedToExtract_other:
          'Se ha producido un error al asignar los metadatos de {{count}} archivos.',
      },
      noFiles: 'No hay archivos para cargar',
      hideAndSelectAllFieldError:
        'El campo {{title}} está configurado como "ocultar y seleccionar todo", lo que solo admite un máximo de 10 elementos.',
      metadataExtractinConfig: {
        label: 'Rellenar los metadatos automáticamente',
        renameFilesLabel:
          'Cambiar el nombre de los archivos según la convención de nomenclatura',
        configOption: {
          fromAI: 'a partir del contenido del archivo',
          fromFileName: 'a partir del nombre del archivo',
          fromUser: 'no rellenar automáticamente',
        },
      },
      documentPreview: {
        title: 'Vista previa del documento',
        aiExtractionExplanation: 'Explicaciones de la extracción mediante IA',
      },
    },
    backToPage: 'Volver a la página',
    forms: {
      placeholders: {
        text: 'Introduzca un valor',
        textarea: 'Introduzca un texto',
        number: 'Introduzca un número (p. ej., {{example}})',
        select: 'Seleccione un valor',
        creatableSelect: 'Seleccione o introduzca un valor',
        date: 'Seleccione una fecha',
        datetime: 'Seleccione una fecha y una hora',
      },
      validationErrors: {
        inputIsRequired: 'Este campo es obligatorio',
        minMaxNumberError: 'Se esperaba {{expected}}',
        exclusiveMaximumError: 'Debe ser menor que {{expected}}',
        exclusiveMinimumError: 'Debe ser mayor que {{expected}}',
        maximumError: 'Debe ser como máximo {{expected}}',
        minimumError: 'Debe ser como mínimo {{expected}}',
        patternError: 'Debe coincidir con el patrón {{pattern}}',
        minDateError: 'La fecha no debe ser anterior a {{date}}',
        maxDateError: 'La fecha no debe ser posterior a {{date}}',
        shouldBeMaxError:
          'La fecha máxima de todas las ventas parciales no debe ser anterior a la fecha de salida',
      },
    },
    updateTableRow: {
      title_one: 'Editar entrada ({{count}} elemento)',
      title_many: 'Editar entradas ({{count}} elementos)',
      title_other: 'Editar entradas ({{count}} elementos)',
      titleForTypeDoc_one: 'Editar documento ({{count}} elemento)',
      titleForTypeDoc_many: 'Editar documentos ({{count}} elementos)',
      titleForTypeDoc_other: 'Editar documentos ({{count}} elementos)',
      updateError_one: 'No se pudo actualizar la entrada',
      updateError_many: 'No se pudieron actualizar {{count}} entradas',
      updateError_other: 'No se pudieron actualizar {{count}} entradas',
      cancel: 'Cancelar',
      submit: 'Enviar',
    },
    navigation: {
      dynamicNavSection: {
        title: 'Páginas de detalle',
        closeAll: 'Cerrar todas',
        errorNotification:
          'Error al cerrar los enlaces a las páginas de detalle',
      },
    },
    dashboard: {
      topNavigation: {
        addDashboard: 'Añadir panel de control',
        allDashboards: 'Todos los paneles de control ({{count}})',
      },
      allDashboardsModal: {
        title: 'Todos los paneles de control',
        instanceSectionTitle: 'Paneles de control en la navegación superior',
        availableSectionTitle: 'Otros paneles de control disponibles',
        instanceSectionEmpty:
          'No se muestra ningún panel de control en la navegación superior.',
        availableSectionEmpty: 'No hay otros paneles de control disponibles.',
        sharingPrivate: 'Privado',
        sharingGlobal: 'Global',
        moveUp: 'Mover hacia arriba',
        moveDown: 'Mover hacia abajo',
        hideTab: 'Ocultar pestaña',
        showTab: 'Mostrar pestaña',
        delete: 'Eliminar',
        restore: 'Restaurar',
        cancel: 'Cancelar',
        save: 'Guardar',
        saveSuccess: 'Navegación de paneles de control actualizada.',
        actionFailed:
          'No se pudo actualizar la navegación de paneles de control. Inténtelo de nuevo.',
      },
      createModal: {
        title: 'Crear panel de control',
        nameLabel: 'Nombre del panel de control',
        descriptionLabel: 'Descripción',
        cancel: 'Cancelar',
        submit: 'Crear panel de control',
        submitFailed:
          'No se pudo crear el panel de control. Inténtelo de nuevo.',
        createInstanceFailed:
          'El panel de control se ha creado, pero no se ha podido añadir a la navegación superior. Puede mostrarlo desde "Todos los paneles de control".',
      },
      deleteConfirmation: {
        title: 'Eliminar panel de control',
        message: '¿Eliminar definitivamente "{{dashboardName}}"?',
        irreversibleWarning:
          'El panel de control se eliminará cuando haga clic en Guardar.',
        permanentWarning: 'Esta acción no se puede deshacer.',
        cancel: 'Cancelar',
        confirm: 'Eliminar',
        deleteFailed:
          'No se pudo eliminar el panel de control. Inténtelo de nuevo.',
        deleteSuccess: 'Panel de control eliminado.',
      },
      shareModal: {
        title: 'Compartir panel de control',
        instruction: 'Elija quién puede ver este panel de control.',
        privateLabel: 'Privado',
        privateDescription: 'Visible solo para usted',
        globalLabel: 'Global',
        globalDescription:
          'Disponible para todos los miembros de la organización',
        submitFailed:
          'No se pudo actualizar la configuración de uso compartido. Inténtelo de nuevo.',
        submitSuccess: 'Configuración de uso compartido actualizada.',
      },
      emptyState: {
        noDashboards: {
          title: 'Cree su primer panel de control',
          description:
            'Cree un panel de control para empezar a configurar su vista personalizada.',
          action: 'Crear panel de control',
        },
        noInstances: {
          title: 'Elija un panel de control',
          description:
            'Abra "Todos los paneles de control" para elegir un panel de control para su navegación superior.',
          action: 'Todos los paneles de control',
        },
        emptyDashboard: {
          title: 'Este panel de control está vacío',
          descriptionOwner:
            'Añada un componente para empezar a configurar su panel de control.',
          descriptionViewer:
            'Este panel de control aún no contiene ningún componente.',
          action: 'Añadir componente',
        },
      },
      loading: 'Cargando el panel de control…',
      editAction: {
        label: {
          editLayout: 'Editar diseño',
          cancel: 'Cancelar',
        },
        saveFailed:
          'No se pudo guardar el panel de control. Inténtelo de nuevo.',
        saveOutcomeUnknown:
          'No se puede confirmar si los cambios se han guardado. Se está recargando el panel de control; siga editando si todavía necesita sus cambios.',
      },
      placeholder: {
        pendingHydration: 'Este componente se cargará después de guardar.',
      },
      unsavedChanges:
        'Tiene cambios sin guardar en el panel de control. ¿Desea salir sin guardar?',
      unsavedChangesModal: {
        title: 'Cambios sin guardar',
        message:
          'Tiene cambios sin guardar en el diseño del panel de control. Permanezca en la página para seguir editando o descarte los cambios y salga.',
        stay: 'Permanecer',
        discard: 'Descartar',
      },
    },
    initFundOperation: {
      title: 'Crear operación del fondo',
      cancel: 'Cancelar',
      submit: 'Enviar',
      successMessage: 'La operación del fondo se ha creado correctamente.',
      fundLoadingError:
        'Se ha producido un error del sistema al cargar los datos del fondo. Cancele este proceso e inténtelo de nuevo.',
      currencyLoadingError:
        'Se ha producido un error del sistema al cargar los datos de las monedas. Cancele este proceso e inténtelo de nuevo.',
      error:
        'Se ha producido un error del sistema. Cancele este proceso e inténtelo de nuevo.',
    },
    createRow: {
      title: 'Crear fila',
      fileUploadRequired: 'Se requiere al menos un archivo.',
      cancel: 'Cancelar',
      submit: 'Enviar',
      okay: 'Aceptar',
      submitting: 'Enviando',
    },
    investmentLimit: {
      title: 'Crear límite',
      cancel: 'Cancelar',
      back: 'Atrás',
      next: 'Siguiente',
      create: 'Crear límite',
      creating: 'Creando',
      steps: {
        overview: 'Configuración general',
        parameter: 'Parámetro',
        denominator: 'Denominador',
        workflow: 'Flujo de trabajo y vigencia',
        review: 'Resumen',
      },
      widgets: {
        overview: 'Vista general',
        comparisonType: 'Tipo de comparación',
        limitParameters: 'Parámetros del límite',
        evaluation: 'Evaluación',
        denominator: 'Denominador',
        workflow: 'Flujo de trabajo',
        validity: 'Vigencia',
        review: 'Revisión',
      },
      mode: {
        aggregation: {
          label: 'Límite de agregación',
          description:
            'Calcula un valor agregado a partir de uno o varios registros antes de compararlo con un límite.',
        },
        position: {
          label: 'Límite por posición',
          description:
            'Evalúa cada registro de forma individual con respecto a una regla o un umbral.',
        },
        exclusion: {
          label: 'Exclusión',
          description:
            'Prohíbe exposiciones por país, estrategia, región o industria.',
        },
        inclusion: {
          label: 'Inclusión',
          description:
            'Permite exposiciones únicamente en el país, la estrategia, la región o la industria especificados.',
        },
      },
      valueType: {
        absolute: {
          label: 'Absoluto',
          description: 'Compara el valor medido directamente con el límite.',
        },
        relative: {
          label: 'Relativo',
          description:
            'Compara el valor medido como proporción de un denominador.',
        },
      },
      limitType: {
        regulatory: 'Regulatorio',
        contractual: 'Contractual',
        client_specific: 'Específico del cliente',
        internal: 'Interno',
      },
      aggregationMethod: {
        sum: 'Suma',
        topN: 'N mayores',
        bottomN: 'N menores',
      },
      dataField: {
        available_capital: 'Capital disponible',
        cumulative_all_commitment: 'Compromiso total acumulado',
        cumulative_all_cost: 'Coste total acumulado',
        cumulative_all_paid_in_inside_commitment:
          'Desembolsos totales acumulados dentro del compromiso',
        cumulative_all_returned: 'Importe total devuelto acumulado',
        days_to_final_termination_date:
          'Días hasta la fecha de terminación definitiva',
        days_to_investment_end_date:
          'Días hasta el fin del periodo de inversión',
        days_to_termination_date: 'Días hasta la fecha de terminación',
        dpi: 'DPI',
        effective_valuation: 'Valoración efectiva',
        exposure: 'Exposición',
        irr: 'TIR',
        nbr_count: 'Recuento',
        rvpi: 'RVPI',
        tvpi: 'TVPI',
        undrawn_commitment: 'Compromiso no desembolsado',
      },
      fields: {
        limitName: 'Nombre del límite',
        limitNamePlaceholder:
          'p. ej., Asignación máx. a fondos de capital privado',
        description: 'Descripción',
        descriptionPlaceholder: 'Describa el propósito de este límite',
        limitType: 'Tipo de límite',
        selectType: 'Seleccione el tipo',
        dataLevel: 'Nivel de datos',
        selectLevel: 'Seleccione el nivel',
        currencyType: 'Tipo de moneda',
        selectCurrencyType: 'Seleccione el tipo de moneda',
        removeFilter: 'Quitar filtro',
        selectNamed: 'Seleccione {{label}}',
        kpi: 'KPI',
        selectKpi: 'Seleccione un KPI',
        requiresDataLevel: 'Requiere la selección del nivel de datos',
        limitOperator: 'Operador del límite',
        operatorPlaceholder: 'Op.',
        limitValue: 'Valor del límite',
        valuePlaceholder: 'Valor',
        warningThreshold: 'Umbral de advertencia',
        warningPlaceholder: 'p. ej., 80 %',
        aggregationMethod: 'Método de agregación',
        selectMethod: 'Seleccione el método',
        aggregationNumber: 'Valor de N del método de agregación',
        aggregationNumberPlaceholder: 'p. ej., 10',
        evaluationMetric: 'Métrica de evaluación',
        selectMetric: 'Seleccione una métrica',
        evaluationOperator: 'Operador de evaluación',
        evaluationValue: 'Valor de evaluación',
        breachApproval: 'Aprobación en caso de incumplimiento del límite',
        validFrom: 'Válido desde',
        selectStartDate: 'Seleccione la fecha de inicio',
        validTo: 'Válido hasta',
        selectEndDate: 'Seleccione la fecha de finalización',
        validIndefinitely: 'Válido indefinidamente (sin fecha de finalización)',
      },
      review: {
        none: 'Ninguno',
        yes: 'Sí',
        no: 'No',
        indefinitely: 'Indefinidamente',
        limitName: 'Nombre del límite',
        limitType: 'Tipo de límite',
        limitMode: 'Modo del límite',
        description: 'Descripción',
        comparisonType: 'Tipo de comparación',
        dataLevel: 'Nivel de datos',
        currencyType: 'Tipo de moneda',
        filters: 'Filtros',
        kpi: 'KPI',
        limitOperator: 'Operador del límite',
        limitValue: 'Valor del límite',
        warningThreshold: 'Umbral de advertencia',
        aggregationMethod: 'Método de agregación',
        aggregationNumber: 'Valor de N del método de agregación',
        evaluationMetric: 'Métrica de evaluación',
        evaluationOperator: 'Operador de evaluación',
        evaluationValue: 'Valor de evaluación',
        breachApproval: 'Aprobación en caso de incumplimiento del límite',
        validFrom: 'Válido desde',
        validTo: 'Válido hasta',
      },
      preview: {
        dataSource: 'Fuente de datos',
        addFilter: 'Añadir filtro',
        topLevelAggregation: 'Agregación de nivel superior',
        singlePositionExpression:
          'Evaluación de la expresión por posición individual',
        kpiLimitComparison: 'Comparación del KPI con el límite',
        overview: 'Vista general',
        parameter: 'Parámetro',
        denominator: 'Denominador',
        workflow: 'Flujo de trabajo y vigencia',
        limitMode: 'Modo del límite',
        denominatorFieldsHint:
          'Los campos de evaluación se configuran en el paso Denominador.',
        inclusionBreachHint:
          'El límite se considera incumplido si en la fuente de datos se encuentra alguna fila que no coincida con los filtros especificados.',
        exclusionBreachHint:
          'El límite se considera incumplido si en la fuente de datos se encuentra alguna fila que coincida con los filtros especificados.',
        denominatorIntro:
          'Seleccione la fuente de datos que servirá de base para el cálculo relativo.',
        allRecords:
          'A continuación se muestran los registros del tipo de moneda seleccionado.',
        filteredRecords:
          'Registros afectados del tipo de moneda seleccionado, según los filtros añadidos.',
        previewPlaceholder:
          'Aquí aparecerá una vista previa de las entidades afectadas en cuanto se seleccionen un nivel de datos y un tipo de moneda.',
        currencyTypePreviewPlaceholder:
          'Seleccione un tipo de moneda para cargar la vista previa. La vista previa solo incluye registros de ese tipo de moneda.',
      },
      createFailed: 'No se pudo crear el límite.',
    },
    dataIngestion: {
      title: 'Nueva importación de datos',
      cancel: 'Cancelar',
      back: 'Atrás',
      next: 'Siguiente',
      upload: 'Cargar y procesar archivo',
      uploading: 'Cargando',
      done: 'Listo',
      configureAndDownload: {
        title: 'Configurar y descargar',
        configureImport: 'Definir los metadatos de la importación',
        noImportConfig:
          'La importación de datos actual no requiere ninguna configuración adicional',
        selectScope: 'Opcional: descargar una plantilla rellenada previamente',
        entitiesLabel:
          'Entidades para las que descargar plantillas rellenadas previamente',
        prefillDataLabel: 'Descargar con las entradas de datos actuales',
        prefillDataHelpText:
          'Si se activa esta opción, la plantilla se rellena previamente con los datos más recientes disponibles según la fecha de referencia de la importación.',
        downloadTemplate: 'Descargar plantilla',
        templateDownload: {
          loading: 'Descargando la plantilla de importación de datos',
          success:
            'Se ha iniciado la descarga de la plantilla de importación de datos',
          error:
            'No se pudo descargar la plantilla de importación de datos: {{- message}}',
        },
      },
      uploadAndParse: {
        title: 'Cargar y procesar',
        templateInput: 'Plantilla cumplimentada',
        executionLog: 'Registro de la importación',
        executionLogPlaceholder:
          'El resultado de la importación aparecerá aquí cuando finalice la carga.',
        executionLogSuccess: 'La importación se ha completado correctamente.',
        executionLogErrorFallback:
          'Se ha producido un error inesperado. Inténtelo de nuevo.',
      },
    },
    pageSidebar: {
      widgetTitle: 'Detalles',
      closeSidebar: 'Cerrar la barra lateral',
      pinSidebar: 'Fijar la barra lateral',
      unpinSidebar: 'Desfijar la barra lateral',
      noDocumentsAvailable: 'No hay documentos disponibles',
      noPreviewAvailable: 'No hay vista previa disponible',
      previewUnavailableNotScanned:
        'Este archivo no se ha analizado en busca de amenazas. La vista previa no está disponible.',
      previewUnavailableMalicious:
        'Este archivo puede contener contenido malicioso y se ha bloqueado. La vista previa no está disponible.',
      download: 'Descargar',
      openInPage: 'Abrir en Documentos',
      errorText:
        'Se ha producido un problema al cargar los documentos relacionados.',
    },
    aiAssistant: {
      addCurrentPage: 'Añadir página',
      addDocuments_one: 'Añadir documento ({{count}})',
      addDocuments_many: 'Añadir documentos ({{count}})',
      addDocuments_other: 'Añadir documentos ({{count}})',
      allChats: 'Todos los chats',
      assistantTitle: 'Asistente de IA de AssetMetrix',
      cancel: 'Cancelar',
      chatListSectionLast30Days: 'Últimos 30 días',
      chatListSectionLast7Days: 'Últimos 7 días',
      chatListSectionOlder: 'Anteriores',
      chatListSectionToday: 'Hoy',
      chatListSectionYesterday: 'Ayer',
      closeAssistant: 'Cerrar el asistente',
      closeSources: 'Cerrar las fuentes',
      collapseCitations: 'Ocultar citas',
      copied: 'Copiado',
      copyReply: 'Copiar la respuesta al portapapeles',
      composerPlaceholder: 'Pregunte al Asistente de IA de AssetMetrix…',
      deleteChat: 'Eliminar chat',
      deleteChatConfirm: 'Eliminar chat',
      deleteChatMessage:
        '¿Está seguro de que desea eliminar este chat? Esta acción no se puede deshacer.',
      deleteChatMessageNamed:
        '¿Está seguro de que desea eliminar “{{title}}”? Esta acción no se puede deshacer.',
      disclaimer:
        'Está interactuando con un sistema de Inteligencia Artificial (IA).',
      disclaimerParagraphs: [
        'Está interactuando con un sistema de Inteligencia Artificial (IA). Las respuestas se generan mediante inteligencia artificial basándose exclusivamente en los contenidos y datos a los que usted tiene autorización para acceder dentro de la AssetMetrix Platform. Aunque el sistema está diseñado para proporcionar información útil y precisa, las respuestas pueden ser incompletas o inexactas y no deben tomarse como asesoramiento jurídico, financiero, regulatorio ni profesional. El Asistente de IA sirve de apoyo, pero no sustituye el criterio humano ni el asesoramiento profesional. La responsabilidad final de todas las decisiones y acciones recae en el usuario.',
        'Verifique siempre la información importante antes de tomar decisiones. El Asistente de IA respeta estrictamente los permisos de usuario y no puede acceder a contenidos que excedan sus derechos de acceso autorizados.',
      ],
      disclaimerTitle: 'Descargo de responsabilidad del Asistente de IA',
      downloadAllDocuments: 'Descargar todos los documentos en un archivo ZIP',
      downloadDocument: 'Descargar documento',
      expandCitations: 'Mostrar citas',
      hideChatList: 'Ocultar la lista de chats',
      hideSources: 'Ocultar fuentes ({{count}})',
      jumpToSource: 'Ir a la fuente {{index}}',
      loadingChats: 'Cargando chats…',
      newChat: 'Nuevo chat',
      open: 'Abrir',
      openAssistant: 'Abrir el Asistente de IA de AssetMetrix',
      openInPreview: 'Abrir en la vista previa',
      overlapPageContent: 'Superponer al contenido de la página',
      pinToPageLayout: 'Fijar al diseño de la página',
      removeDocumentContext: 'Quitar {{label}}',
      removePageContext: 'Quitar {{label}}',
      requestError:
        'La solicitud al Asistente de IA ha fallado. Inténtelo de nuevo.',
      sendMessage: 'Enviar mensaje',
      showChatList: 'Mostrar la lista de chats',
      showSources: 'Mostrar fuentes ({{count}})',
      sourcesDocumentCount_one: '{{count}} documento',
      sourcesDocumentCount_many: '{{count}} documentos',
      sourcesDocumentCount_other: '{{count}} documentos',
      sourcesLinkCount_one: '{{count}} enlace',
      sourcesLinkCount_many: '{{count}} enlaces',
      sourcesLinkCount_other: '{{count}} enlaces',
      sourcesTitle: 'Fuentes ({{count}})',
      sourcesTitleDocumentsAndLinks: 'Fuentes ({{documents}}, {{links}})',
      sourcesTitleLinks_one: 'Fuentes ({{count}} enlace)',
      sourcesTitleLinks_many: 'Fuentes ({{count}} enlaces)',
      sourcesTitleLinks_other: 'Fuentes ({{count}} enlaces)',
      thinking: 'Pensando…',
    },
    pdfDocumentPreview: {
      close: 'Cerrar la vista previa',
      closeSearch: 'Cerrar la búsqueda',
      currentPage: 'Página actual',
      disableHandTool: 'Desactivar la herramienta de mano',
      documentDetails: 'Detalles del documento',
      download: 'Descargar',
      fitPage: 'Ajustar a la página',
      fitWidth: 'Ajustar al ancho',
      handTool: 'Herramienta de mano (desplazar)',
      hideDocumentDetails: 'Ocultar los detalles del documento',
      hidePages: 'Ocultar páginas',
      horizontalLayout: 'Diseño horizontal',
      loading: 'Cargando el documento…',
      loadingError: 'No se pudo cargar este documento.',
      moreTools: 'Más herramientas',
      nextMatch: 'Siguiente coincidencia',
      noResults: 'Sin resultados',
      previousMatch: 'Coincidencia anterior',
      print: 'Imprimir',
      rotate: 'Girar',
      search: 'Buscar',
      searchPlaceholder: 'Buscar en el documento…',
      searchTitle: 'Buscar (Ctrl/Cmd+F)',
      showPages: 'Mostrar páginas',
      title: 'Vista previa del documento',
      verticalLayout: 'Diseño vertical',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
    },
    vegaChartWidget: {
      groupingError:
        'No se ha configurado la agrupación de columnas para las columnas de datos',
    },
    textFromTableWidget: {
      errorLoadingData: 'No se pudieron cargar los datos dinámicos',
      missingColumnConfig:
        'Falta la configuración de columnas para los marcadores de posición: {{keys}}',
      noDataFound: 'No se encontraron datos',
    },
    stakeAdjustment: {
      label: 'Ajustado por participación',
      tooltip:
        'Ajustar todos los datos de inversión a la participación directa del inversor',
    },
  },
} as const;

export default es;
